module.exports = __webpack_public_path__ + "img/8bf52f1.jpg";